import React from 'react';
import Reflux from 'reflux';
import {Button, Row, Col, Modal, Radio, Select, Input, message, Popconfirm} from 'antd';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView, AdvanceFormNew} from '../../components';
import {openNotice} from 'Utils';
import {
    getOrderTraceBackistList,
    getGouXiaoUnitList,
    getProductLineList,
    deleterRecord
} from '../../service/traceOrder';
/*获取订单追溯产品列表接口*/
import {debug} from 'util';

// import moment from 'moment';
class TraceOrderList extends Reflux.Component {
    constructor(props) {
        super(props);
        this.channelData = window.sessionStorage.getItem('cur_channel') || '{}';
        this.state = {
            opts: ['追溯订单'],
            showHideBtnIndex: '',
            key: 0,
            prolineVisible: false,
            selectedRowKeys: [],
            gouxiaoUnitList: [],
            productLineData: [],
            rows: [],

            // rows: [{
            //   key: '0',
            //   id: '9100002334',
            //   status: '浙江电工张华',
            //   type: '12123123123',
            //   date: '已提交',
            //   customerName: '2017-12-12',
            //   purchaseUnit: '1111111',
            //   amount: '个啊实打实大',
            //   cash: '元器件'
            // }, {
            //   key: '1',
            //   id: '9100002331',
            //   status: '浙江电工张华',
            //   type: '123123123123',
            //   date: '通过',
            //   customerName: '2017-12-11',
            //   purchaseUnit: '22222222',
            //   amount: '件休闲鞋',
            //   cash: 'TG精品'
            // }],
            total: 1,
            searchObj: {
                // name: '',
                proLine: '',
                orderStatus: '',
                salesChannelCode: this.channelData.split('|')[1] || '',
                salesUnitId: '',
                startCreatedDate: '',
                endCreatedDate: '',
                // category: [],
                // active: '',
                s: 10,
                p: 1
            },
            categoryData: [],
            visible: false,
            value: '',
            loading: true
        };
        this.pageChange = this.pageChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);

        this.handleOk = this.handleOk.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.onChange = this.onChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
    };

    /*选择列表*/
    onSelectChange = (selectedRowKeys) => {
    };

    /*路径跳转*/
    goView(url) {
        hashHistory.push(url);
    };

    /*筛选*/
    setFilterParam(name, value) {
        // console.log(name);
        if (name == 'shipTime') {
            this.setState({
                searchObj: {
                    ...this.state.searchObj,
                    startCreatedDate: value.from + ' 00:00:00',
                    endCreatedDate: value.end + ' 23:59:59'
                }
            })
        } else {
            this.setState({searchObj: {...this.state.searchObj, [name]: value}});
        }

    };

    /*筛选重置*/
    advanceReset() {
        this.setState({
            searchObj: {
                proLine: '',
                orderStatus: '',
                salesUnitId: '',
                salesChannelCode: this.channelData.split('|')[1] || '',
                startCreatedDate: '',
                endCreatedDate: '',
                s: 10,
                p: 1
            }, loading: true
        }, () => {
            this.initData();
        });
    };

    /* 筛选确认 */
    advanceSubmit(form) {
        let self = this;
        this.setState({
            searchObj: {
                ...this.state.searchObj,
                p: 1
            }, loading: true
        }, function () {
            self.initData();
        });
    };

    /*翻页*/
    pageChange(page, pageSize) {
        let self = this;
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}, loading: true}, function () {
            self.initData();
        });
    }

    /*获取列表数据*/
    initData() {
        let self = this;
        let obj = self.state.searchObj;
        getOrderTraceBackistList(obj).then(result => {
            if (result.status) {
                this.setState({
                    rows: result.data || [],
                    total: result.total,
                    loading: false
                })
            } else {
                message.error(result.message);
                this.setState({loading: false});
            }
        })

    }

    //离开当前路由时，更新store
    routeLeaveHook(nextLocation) {
    }

    componentWillMount() {
    }

    componentDidMount() {
        let self = this;
        let channelCode = window.sessionStorage.getItem('cur_channelId');
        this.initData();
        getGouXiaoUnitList({channelCode: channelCode, s: 999}).then(res => { //购货单位
            if (res.status) {
                const data = res.data || [];
                let arr = [
                    {
                        text: '全部',
                        value: '0'
                    }
                ];
                for (let i = 0; i < data.length; i++) {
                    let x = data[i];
                    arr.push({
                        text: x.name,
                        value: x.id
                    })
                }
                self.setState({gouxiaoUnitList: arr})
            }
        });
        getProductLineList().then(result => { //产品线
            if (result.status) {
                let arr = [
                    {
                        text: '全部',
                        value: ''
                    }
                ];
                for (let i = 0; i < result.data.length; i++) {
                    let x = result.data[i];
                    arr.push({
                        text: x.name,
                        value: x.code
                    })
                }
                this.setState({
                    productLineData: arr
                })
            } else {
                message.error(result.message);
            }
        })
        //设置离开当前路由时的钩子函数
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    }

    showHideBtn(index) {
        this.setState({
            showHideBtnIndex: index
        });
    }

    hideBtn() {
        this.setState({
            showHideBtnIndex: ''
        });
    }

    editRecord(record) {
        this.goView('traceOrder/edit/' + record.id);
    }

    deleteItem(record) {
        deleterRecord({id: record.id}).then(res => {
            if (res.code === 200) {
                openNotice('success', '删除成功');
                this.initData();
            }
        });
    }

    handleOk = () => {
        this.setState({visible: false});
    }

    handleCancel = () => {
        this.setState({visible: false});
    }

    onChange = (e) => {
        this.setState({
            value: e.target.value
        });
    }

    handleChange() {

    }

    render() {
        var self = this;
        const {opts, key, rows, total, searchObj, selectedRowKeys, showHideBtnIndex, visible, gouxiaoUnitList, productLineData, loading} = this.state;
        const advanceProps = {
            fileds: [
                // {
                //     name: 'id',
                //     label: '编号',
                //     text: '输入编号',
                //     type: 'default',
                //     defaultValue: searchObj.id
                // },
                // {
                //     name: 'proLine',
                //     label: '产品线',
                //     text: '选择状态',
                //     options: productLineData,
                //     multiple: false,
                //     type: 'select',
                //     defaultValue: searchObj.proLine
                // },
                {
                    name: 'status',
                    label: '状态',
                    text: '选择状态',
                    options: [
                        //'1,提交，2，待审批  3已确认 4，已完成5，驳回，6，驳回后提交',
                        {value: '', text: '全部'},
                        {value: '1', text: '已提交'},
                        // { value: '2', text: '待审批' },
                        {value: '3', text: '已确认'},
                        {value: '4', text: '已完成'},
                        {value: '5', text: '驳回'},
                        {value: '6', text: '驳回后提交'}
                    ],
                    multiple: false,
                    type: 'select',
                    defaultValue: searchObj.orderStatus
                },
                {
                    name: 'salesUnitId',
                    label: '购货单位',
                    text: '输入购货单位',
                    type: 'select',
                    multiple: false,
                    showSearch: true,
                    options: gouxiaoUnitList,
                    defaultValue: searchObj.salesUnitId
                },
                {
                    name: 'shipTime',//startCreatedDate, endCreatedDate
                    label: '登记日期',
                    options: [
                        {text: '开始时间'},
                        {text: '结束时间'},
                    ],
                    type: 'dateComp',
                    defaultValue: {
                        from: searchObj.starCreatedDate,
                        end: searchObj.endCreatedDate
                    }
                }
            ],
            handle: this.advanceSubmit,
            reset: this.advanceReset,
            fieldHandle: this.setFilterParam
        };
        const tableViewProps = {
            loading: loading,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total: total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [

                {
                    title: '要货单号',
                    dataIndex: 'orderNumber',
                    render: (text, record, index) => {
                        return <a href={`#/traceOrder/${record.id}`}>{text}</a>
                    }
                },
                // {
                //   title: 'ERP要货单号',
                //   dataIndex: 'headerId',
                //   render: (text, record, index) => {
                //     return <a href={`#/traceOrder/${record.id}`}>{text}</a>
                //   }
                // },
                {
                    title: '客户名称',
                    dataIndex: 'cusName'
                },
                {
                    title: '购货单位',
                    dataIndex: 'purchaseName'
                },
                {
                    title: '渠道',
                    dataIndex: 'channelName'
                },
                // {
                //     title: '产品线',
                //     dataIndex: 'productLineName'
                // },
                {
                    title: '状态',
                    dataIndex: 'status',
                    render: (text) => {
                        //'1,提交，2，待审批  3 已确认 4，已完成5，驳回，6，驳回后提交',
                        if (text === 1) {
                            return '已提交'
                        }
                        if (text === 2) {
                            return '保存'
                        }
                        if (text === 3) {
                            return '已确认'
                        }
                        if (text === 4) {
                            return '已完成'
                        }
                        if (text === 5) {
                            return '驳回'
                        }
                        if (text === 6) {
                            return '驳回后提交'
                        }
                    }
                },
                {
                    title: '日期',
                    dataIndex: 'orderDate'
                },
                {
                    title: '订单号',
                    dataIndex: 'headerNumber'
                },
                {
                    title: '反馈',
                    dataIndex: 'feedback'
                },
                {
                    title: '创建人',
                    dataIndex: 'createdName'
                },
                {
                    title: '操作',
                    render: (text, record, index) =>
                        <div>
                            {record.status === 2 || record.status == 5 ?
                                <div className="event">
                                    <Button style={{display: 'inline-block', marginRight: '10px'}} size={'small'}
                                            type="ghost"
                                            onClick={() => {
                                                this.editRecord(record)
                                            }}>编辑</Button>
                                    <Popconfirm placement="left" title='您确定要删除吗！' onConfirm={() => {
                                        this.deleteItem(record)
                                    }}>
                                        <Button size={'small'} type="danger">删除</Button>
                                    </Popconfirm>
                                </div> :
                                <span className="btn">暂无操作</span>}
                        </div>
                }
            ],
            rows
        };
        return <div>
            <DmsTab options={opts} defaultKey={key}></DmsTab>
            <div className="advanceForm-box">
                <div className="advanceForm-content">
                    <AdvanceFormNew {...advanceProps} />
                </div>
            </div>
            <div className="dms-table-box">
                <div className="dms-table-head">
                    <Button style={{position: 'absolute', bottom: 8, left: 0}}
                            onClick={this.goView.bind(this, '/traceOrder/add')}>创建</Button>
                </div>
                <TableView {...tableViewProps} />
            </div>

            <Modal
                visible={visible}
                title="入库"
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                maskClosable={false}
                width={800}
            >
                <div>
                    <Row>
                        <Col>
                            <label className="ant-form-item-required">是否增加库存：</label>
                            <Radio.Group onChange={self.onChange} value={this.state.value}>
                                <Radio value={'Y'}>是</Radio>
                                <Radio value={'N'}>否</Radio>
                            </Radio.Group>
                        </Col>
                    </Row>
                    <Row style={{marginTop: 10}}>
                        <Col>
                            <label>子库存：</label>
                            <Select defaultValue="jack" style={{width: 120}} onChange={self.handleChange}>
                                <Select.Option value="jack">电力01库</Select.Option>
                                <Select.Option value="lucy">电力02库</Select.Option>
                            </Select>
                        </Col>
                    </Row>
                    <Row style={{marginTop: 10}}>
                        <Col>
                            <label className="ant-form-item-required">验证码：</label>
                            <Input style={{width: 65}} maxLength='6'/>
                            <Button style={{marginLeft: 10}}>获取验证码</Button>
                            <span style={{fontSize: 'xx-small', display: 'none'}}>已向授权收货人手机：13888888888发送短信</span>
                        </Col>
                    </Row>
                </div>
            </Modal>

        </div>
    }
}
;
export default withRouter(TraceOrderList);



// WEBPACK FOOTER //
// ./src/routes/traceOrder/list.js